/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import PropTypes from 'prop-types'
import {
    Divider,
    Icon,
    Loader,
    Message,
    Table,
    TableBody,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import ProductSyncStatePlatformItem from './ProductSyncStatePlatformItem'
import { getPosItemSyncStates } from '../../../services/Item/Item.service'
import { useQuery } from '@tanstack/react-query'


const ProductSyncState = ({product}) => {
    const [t] = useTranslation()

    const {data: syncStates, isLoading} = useQuery({
        queryKey: ['items', product.id, 'sync-states'],
        queryFn: () => getPosItemSyncStates(product.id),
        enabled: product.id !== undefined,
    })

    if (isLoading) {
        return (
          <>
              <Divider />
              <Loader active inline="centered"/>
          </>
        )
    }

    if (syncStates && syncStates.length === 0) {
        return (
          <>
              <Divider />
              <Message warning
                       css={css`
                           text-align: center;
                       `}
              >
                  <Icon name="warning sign"/>
                  {t('product_details.unpublished')}
              </Message>
          </>
        )
    }

    return (
      <>
          <Divider />
          <Table basic="very">
              <TableHeader>
                  <TableRow>
                      <TableHeaderCell>{t('product_details.digitalMerchant')}</TableHeaderCell>
                      <TableHeaderCell>{t('product_details.platform')}</TableHeaderCell>
                      <TableHeaderCell>{t('product_details.price')}</TableHeaderCell>
                      <TableHeaderCell>{t('product_details.stock')}</TableHeaderCell>
                      <TableHeaderCell>{t('product_details.sync_state')}</TableHeaderCell>
                      <TableHeaderCell>{t('product_details.sync_date')}</TableHeaderCell>
                  </TableRow>
              </TableHeader>
              <TableBody>
                  {syncStates && syncStates.map(syncState =>
                    <ProductSyncStatePlatformItem
                      key={`${syncState.platform.name}-${syncState.platform.id}`}
                      pf={syncState}
                    />,
                  )}
              </TableBody>
          </Table>
      </>
    )
}

ProductSyncState.propTypes = {
    product: PropTypes.object.isRequired,
}

export { ProductSyncState }
